import React, { useRef, useEffect } from "react";
import './ModalWindow.css';
import {ReactComponent as CloseBtn} from './static/closeModal.svg';
import { useOutsideClick } from "../../../shared/hooks/useOutsideClick";
import { ReactComponent as ModalLogo } from "./static/modalLogo.svg"

/**
 * @param {{
 * title?: import('react').ReactNode, freezeEsc?: boolean, titleType?: string,
 * headerSize?: number, description?: import('react').ReactNode,
 * children?: import('react').ReactNode, logo?: boolean,
 * logoPayload?: import('react').ReactNode, buttons?: import('react').ReactNode,
 * modalShow: boolean, updateModalState: Function, disabledCloseBtn?: boolean,
 * disabledOutsideClose?: boolean, position?: import('react').CSSProperties['alignItems'],
 * dropPaddings?: boolean, gap?: string
 * }} props
 */
export const ModalWindow = ({title, freezeEsc=true, titleType, headerSize, description, children, logo, logoPayload, buttons, modalShow, updateModalState, disabledCloseBtn, disabledOutsideClose, position, dropPaddings, gap='16px'}) => {
    const refCloseModal = useRef();
    useOutsideClick(refCloseModal, (e) => updateModalState(false), modalShow);
    
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Tab') {
                e.preventDefault()
                if (e.shiftKey) { 
                    e.preventDefault()
                }
            }
            if (e.key === 'Enter') {
                e.preventDefault()
            }
            if (e.key === 'Escape') {
                if (freezeEsc) {
                    e.stopPropagation()
                } else {
                    e.preventDefault()
                    updateModalState(false)
                }
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
        // eslint-disable-next-line
    }, [modalShow])

    useEffect(() => {
        if (modalShow) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }

        return () => (document.body.style.overflow = "unset");
    }, [modalShow]);

    return (
        <div id="openModal" className={`modalWindow ${modalShow ? 'open' : ''}`} style={{alignItems: position}} data-portal="true">
            <div className="modalWindow__container" style={dropPaddings && {padding: 0}} ref={disabledOutsideClose === true ? null : refCloseModal}>
                    <div className="modalWindow__close" style={disabledCloseBtn ? {display: "none"} : null} onClick={() => updateModalState(false)}>
                    <CloseBtn className="modalWindows_close-btn"/>
                    </div>
                {logo && <div className="modalWindow__logo">
                        <ModalLogo />
                </div>}
                <div className="modalWindow__content" style={{gap: `${gap}`}}>
                    <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                        {
                            title && 
                            <div className={`modalWindow__header ${titleType}`}>
                                {logoPayload && logoPayload}
                                <h1 className={`modalWindow__title ${titleType}`} style={{fontSize: `${headerSize}px` ?? null}}>{title}</h1>
                            </div>
                        }
                        {
                            description &&
                            <div className="modalWindow__body">    
                                <p className="modalWindow__body-description">
                                    {description} 
                                </p>
                            </div>
                        }
                    </div>
                    {children}
                </div>
                { buttons &&
                    <div className="modalWindow__btn-group">
                        {buttons}
                    </div>
                }
            </div>
        </div>
    )
}
